import React, { useState, useEffect, useContext, useRef } from "react";
import css from "./side_menu.module.scss";
import * as Icon from"re_redesigned_componnents/icon";
import PermanentDrawerWrapper from "re_redesigned_componnents/drawer/PermanentDrawerWrapper";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import {
  IconArrow,
  IconSideLogout,
} from "re_redesigned_componnents/icon";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { withUserContext, withApiContext } from "context";
import { useHistory } from "react-router-dom";
import LogoutButton from "../../re_redesigned_componnents/logout/Logout";
import { useMediaQuery } from "@mui/material";
import {
  DashboardContexProvider,
  DashboardContext,
} from "re_redesigned_componnents/context/Context";

function SideMenu(props) {
  const { showMenu } = useContext(DashboardContext);
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const history = useHistory();
  const location = useLocation();
  const showButton = location.pathname !== "/";
  
  const currentUser = props.ctx_user.user || {};
  const isParent = String(currentUser.type) === "4" || String(currentUser.member_type) === "4";
  const isTrainer = String(currentUser.type) === "2" || String(currentUser.member_type) === "2";
  const isStudent = String(currentUser.type) === "1" || String(currentUser.member_type) === "1";
  const userName = currentUser.firstName || currentUser.name || "Aarav Sharma";
  const userInitials = userName.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();

  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [childrenList, setChildrenList] = useState([]);
  const [activeChildId, setActiveChildId] = useState(null);

  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setIsProfileMenuOpen(false);
      }
    };
    if (isProfileMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isProfileMenuOpen]);

  const DynamicMenu = (menuName, itemName) => {
    if (itemName === "Profile Settings") {
      const MenuItem = Icon["IconProfileSettings"];
      return MenuItem ? <MenuItem /> : null;
    }
    const MenuItem = Icon[menuName];

    if (!MenuItem) {
      return null;
    }

    return <MenuItem/>;
  };
  const [menuItem, setMenuItem] = useState([]);
  useEffect(() => {
    const user = props.ctx_user.user;
    const fetchDetails = async (endpoint, arg) => {
      try {
        const rsp = await props.ctx_api.privateRequest({
          cmd: endpoint,
          args: arg,
        });
        console.log("rsp...", rsp);
        setMenuItem(rsp.rsp);
      } catch (e) {
        console.log(e);
        return null;
      }
    };

    fetchDetails("get_member_menu", { newUser: user.newUser ? 1 : 0 });

    if (isParent) {
      const organizationId = user.organizationId;
      const roleId = user.roleId;
      const campus = user.campusList && user.campusList.find(
        (d) => d.campus_role_id == `${organizationId} : ${roleId}`
      );
      if (campus && campus.member_type === 4) {
        const campusId = campus.organization_id;
        props.ctx_api.privateRequest({
          cmd: 'get_parent_childrn',
          args: { campusId }
        }).then(({ rsp }) => {
          if (rsp && rsp.length > 0) {
            setChildrenList(rsp);
            setActiveChildId(rsp[0].child_id);
          }
        }).catch(err => console.log(err));
      }
    }
  }, []);



  const [selectedMenu, setSelectedMenu] = useState(0);
  const [openMenus, setOpenMenus] = useState({});
  const shouldShowDrawer = !isSmallScreen || showMenu;

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  };

  const isJoinOrPlayback = (name) => {
    if (!name) return false;
    const lower = name.toLowerCase();
    return lower === "join" || lower.includes("playback");
  };

  const groupMenuItems = (items) => {
    if (!items || items.length === 0) return [];

    let homeItem = null;
    let classItem = null;
    const librarySub = [];
    const assessmentsSub = [];
    const classroomSub = [];
    const normalItems = [];

    items.forEach((item) => {
      if (!item.menu_name) {
        normalItems.push(item);
        return;
      }
      const name = item.menu_name.toLowerCase();
      const route = (item.route || "").toLowerCase();

      // Ignore database empty placeholders for our grouped main menus or items without submenus
      if (
        name === "library" || 
        name === "reports" ||
        name === "report" ||
        (!isStudent && (
          name === "assessments" || 
          name === "assessment" || 
          name.includes("virtual classroom") ||
          name.includes("virtualclassroom") ||
          name === "class" ||
          name === "classes"
        ))
      ) {
        return;
      }

      // Check Home
      if (name === "home" || name === "dashboard" || route === "/") {
        homeItem = item;
      }
      // Check Class
      else if (name === "class" || name === "classes" || route === "/class" || route === "/classes") {
        classItem = item;
      }
      // Check Library: module, chapter, course, course publish
      else if (name === "module" || name === "modules" || route.includes("/modules")) {
        librarySub.push({ ...item, menu_name: "module" });
      } else if (name === "chapter" || name === "chapters" || route.includes("/chapters")) {
        librarySub.push({ ...item, menu_name: "chapter" });
      } else if (name === "course" || name === "courses" || route === "/courses") {
        librarySub.push({ ...item, menu_name: "course" });
      } else if (name.includes("course publish") || route.includes("/course-publish")) {
        librarySub.push({ ...item, menu_name: "course publish" });
      }
      // Check Assessments: question bank, create test, publish test
      else if (name.includes("question bank") || route.includes("/question-bank")) {
        assessmentsSub.push({ ...item, menu_name: "question bank" });
      } else if (name.includes("create test") || route.includes("/create-test")) {
        assessmentsSub.push({ ...item, menu_name: "create test" });
      } else if (name.includes("publish test") || route.includes("/publish-test")) {
        assessmentsSub.push({ ...item, menu_name: "publishtest" });
      }
      // Check Virtual Classroom: rooms, sessions, attendance (but NOT attendance record)
      else if (name === "room" || name === "rooms" || route.includes("/rooms")) {
        classroomSub.push({ ...item, menu_name: "rooms" });
      } else if ((name === "session" || name === "sessions" || route.includes("/sessions")) && !name.includes("live")) {
        classroomSub.push({ ...item, menu_name: "sessions" });
      } else if (
        (name.includes("attendance") || name.includes("attendence") || route.includes("/attendance")) &&
        !name.includes("record") &&
        !route.includes("record")
      ) {
        if (isParent) {
          normalItems.push(item);
        } else {
          classroomSub.push({ ...item, menu_name: "attendance" });
        }
      }
      // Otherwise, normal menu item (e.g. fee management, attendance record, etc.)
      else {
        normalItems.push(item);
      }
    });

    const result = [];

    // 1. Home is first
    if (homeItem) {
      result.push(homeItem);
    }

    // 2. Class is second
    if (classItem) {
      result.push(classItem);
    }

    // 3. Grouped sections (if they have children)
    if (librarySub.length > 0) {
      result.push({
        isGrouped: true,
        menu_name: "Library",
        logo: "IconMenuProgram",
        submenus: librarySub,
      });
    }

    if (assessmentsSub.length > 0) {
      result.push({
        isGrouped: true,
        menu_name: "Assessments",
        logo: "IconMenuAssessment",
        submenus: assessmentsSub,
      });
    }

    if (classroomSub.length > 0 && !isParent) {
      result.push({
        isGrouped: true,
        menu_name: "Virtual Classroom",
        logo: "IconClassroom",
        submenus: classroomSub,
      });
    }

    // 4. Other normal items (attendance will naturally end up here as flat main menu items)
    result.push(...normalItems);

    return result;
  };

  const rawMainMenus = menuItem.filter((ele) => !isJoinOrPlayback(ele.menu_name));
  const mainMenus = groupMenuItems(rawMainMenus);
  const subMenusLive = menuItem.filter((ele) => isJoinOrPlayback(ele.menu_name));

  useEffect(() => {
    if (!menuItem || menuItem.length === 0) return;
    const currentPath = location.pathname.toLowerCase();
    
    let found = false;
    
    mainMenus.forEach((ele) => {
      if (ele.isGrouped) {
        ele.submenus.forEach((sub) => {
          if (sub.route && currentPath === sub.route.toLowerCase()) {
            setSelectedMenu(sub.menu_name);
            setOpenMenus((prev) => ({ ...prev, [ele.menu_name]: true }));
            found = true;
          }
        });
      } else {
        if (ele.route && currentPath === ele.route.toLowerCase()) {
          setSelectedMenu(ele.menu_name);
          found = true;
        } else if (currentPath === "/" && (ele.menu_name.toLowerCase() === "home" || ele.route === "/")) {
          setSelectedMenu(ele.menu_name);
          found = true;
        } else if (currentPath === "/curricula" && ele.menu_name === "curriculum") {
          setSelectedMenu(ele.menu_name);
          found = true;
        } else if (currentPath === "/fee-management" && ele.menu_name.toLowerCase().includes("fee management")) {
          setSelectedMenu(ele.menu_name);
          found = true;
        }
      }
    });
    
    if (!found) {
      subMenusLive.forEach((sub) => {
        if (sub.route && currentPath === sub.route.toLowerCase()) {
          setSelectedMenu(sub.menu_name);
          setOpenMenus((prev) => ({ ...prev, ["Live Sessions"]: true, ["Live Session"]: true }));
        }
      });
    }
  }, [location.pathname, menuItem]);

  return (
    shouldShowDrawer && (
      <PermanentDrawerWrapper>
        <div className={css.menu_wrap}>
       { mainMenus.sort((a, b) => (a.menu_name === "Profile Settings" ? 1 : b.menu_name === "Profile Settings" ? -1 : 0)).map((ele, index) => {
            const isLiveSession = ele.menu_name && (ele.menu_name.toLowerCase() === "live sessions" || ele.menu_name.toLowerCase() === "live session");
            const isOpen = openMenus[ele.menu_name];
            const isSelected = selectedMenu === ele.menu_name;

            return (
              <React.Fragment key={index}>
                <div
                  className={css.list_wrap}
                  id={isSelected ? css.active_font : undefined}
                  onClick={() => {
                    if (isLiveSession || ele.isGrouped) {
                      toggleMenu(ele.menu_name);
                    } else {
                      setSelectedMenu(ele.menu_name);
                      history.push(
                        ele.menu_name.toLowerCase() === "home" || ele.route === "/"
                          ? "/"
                          : ele.menu_name === "curriculum"
                          ? "/curricula"
                          : ele.menu_name?.toLowerCase()?.includes("performance") || (ele.route === "/configuration" && (props.ctx_user?.user?.type === 4 || props.ctx_user?.user?.member_type === 4))
                          ? "/performance"
                          : (ele.menu_name?.toLowerCase()?.includes("attendance") || ele.menu_name?.toLowerCase()?.includes("attendence")) && (props.ctx_user?.user?.type === 4 || props.ctx_user?.user?.member_type === 4)
                          ? "/attendance-log"
                          : ele.menu_name?.toLowerCase()?.includes("fee management")
                          ? (props.ctx_user?.user?.type === 4 || props.ctx_user?.user?.member_type === 4 ? "/fee-payment" : "/fee-management")
                          : ele.route
                      );
                    }
                  }}
                >
                  <div
                    className={isSelected ? css.active : ""}
                    style={{
                      width: isSelected ? "8px" : "0px",
                      transition: "width 0.15s ease-in-out", // Smooth transition for both directions
                    }}
                  ></div>
                  {DynamicMenu(ele.logo,ele.menu_name)}
                  {ele.menu_name}
                  {((isLiveSession && subMenusLive.length > 0) || (ele.isGrouped && ele.submenus.length > 0)) && (
                    <div className={`${css.chevron} ${isOpen ? css.open : ""}`}>
                      <KeyboardArrowDownIcon sx={{ fontSize: 22, color: '#b1b1b1' }} />
                    </div>
                  )}
                </div>
                
                {isLiveSession && isOpen && (
                  <div className={css.submenu_container}>
                    {subMenusLive.map((child, childIndex) => {
                      const isChildActive = selectedMenu === child.menu_name;
                      return (
                        <div
                          key={`child-${childIndex}`}
                          className={css.sub_list_wrap}
                          id={isChildActive ? css.active_font : undefined}
                          onClick={() => {
                            setSelectedMenu(child.menu_name);
                            history.push(
                              child.menu_name === "curriculum"
                                ? "/curricula"
                                : child.menu_name?.toLowerCase()?.includes("performance") || (child.route === "/configuration" && (props.ctx_user?.user?.type === 4 || props.ctx_user?.user?.member_type === 4))
                                ? "/performance"
                                : (child.menu_name?.toLowerCase()?.includes("attendance") || child.menu_name?.toLowerCase()?.includes("attendence")) && (props.ctx_user?.user?.type === 4 || props.ctx_user?.user?.member_type === 4)
                                ? "/attendance-log"
                                : child.menu_name?.toLowerCase()?.includes("fee management")
                                ? (props.ctx_user?.user?.type === 4 || props.ctx_user?.user?.member_type === 4 ? "/fee-payment" : "/fee-management")
                                : child.route
                            );
                          }}
                        >
                          <div
                            className={isChildActive ? css.active : ""}
                            style={{
                              width: isChildActive ? "8px" : "0px",
                              transition: "width 0.15s ease-in-out",
                            }}
                          ></div>
                          {DynamicMenu(child.logo,child.menu_name)}
                          {child.menu_name}
                        </div>
                      );
                    })}
                  </div>
                )}

                {ele.isGrouped && isOpen && (
                  <div className={css.submenu_container}>
                    {ele.submenus.map((child, childIndex) => {
                      const isChildActive = selectedMenu === child.menu_name;
                      return (
                        <div
                          key={`child-${childIndex}`}
                          className={css.sub_list_wrap}
                          id={isChildActive ? css.active_font : undefined}
                          onClick={() => {
                            setSelectedMenu(child.menu_name);
                            history.push(
                              child.menu_name === "curriculum"
                                ? "/curricula"
                                : child.route
                            );
                          }}
                        >
                          <div
                            className={isChildActive ? css.active : ""}
                            style={{
                              width: isChildActive ? "8px" : "0px",
                              transition: "width 0.15s ease-in-out",
                            }}
                          ></div>
                          {DynamicMenu(child.logo, child.menu_name)}
                          {child.menu_name}
                        </div>
                      );
                    })}
                  </div>
                )}
              </React.Fragment>
            );
          })}
          {showButton && !isParent && !isTrainer && (
            <div className={css.logout}>
              <LogoutButton onLogout={props.onLogout}>
                <button>
                  <IconSideLogout />
                  logout
                </button>
              </LogoutButton>
            </div>
          )}

          {isParent && (() => {
            const activeChild = childrenList.find(c => c.child_id === activeChildId) || {};
            const activeChildName = activeChild.child_name || userName;
            const activeChildInitials = activeChildName.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
            const activeChildClass = activeChild.class_name || "Grade 8 • Section B";

            return (
            <div className={css.parent_profile_section} ref={popoverRef}>
              <div 
                className={css.profile_switch_btn}
                onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
              >
                <div className={css.profile_info_left}>
                  <div className={css.profile_avatar}>{activeChildInitials}</div>
                  <div className={css.profile_text}>
                    <h4>{activeChildName}</h4>
                    <p>{activeChild.child_class}</p>
                  </div>
                </div>
                {childrenList.length > 1 && (
                  <KeyboardArrowDownIcon sx={{ 
                    transform: isProfileMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                    color: '#b1b1b1' 
                  }} />
                )}
              </div>

              {isProfileMenuOpen && childrenList.length > 1 && (
                <div className={css.profile_popover}>
                  <div className={css.popover_header}>Switch Student</div>
                  <div className={css.popover_body}>
                    {childrenList.map((child) => {
                      const isActive = child.child_id === activeChildId;
                      const childInitials = child.child_name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
                      return (
                        <div 
                          key={child.child_id}
                          className={`${css.profile_dropdown_item} ${isActive ? css.active : ''}`}
                          onClick={() => {
                            setActiveChildId(child.child_id);
                            setIsProfileMenuOpen(false);
                            if (props.handleChildChange) {
                              props.handleChildChange({ value: child.child_id, label: child.child_name });
                            }
                          }}
                        >
                          <div className={css.profile_info_left}>
                            <div className={css.profile_avatar}>{childInitials}</div>
                            <div className={css.profile_text}>
                              <h4>{child.child_name}</h4>
                              <p>{child.child_class}</p>
                            </div>
                          </div>
                          {isActive && (
                           <div className={css.active_check}>✓</div>
                           )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}


              <div className={css.profile_actions}>
                <LogoutButton onLogout={props.onLogout}>
                  <button className={css.parent_logout_btn}>
                    <IconSideLogout />
                    Log out
                  </button>
                </LogoutButton>
              </div>
            </div>
            );
          })()}

          {/* {isTrainer && (
            <div className={css.parent_profile_section}>
              <div 
                className={css.profile_switch_btn}
                onClick={() => history.push("/profile-settings")}
              >
                <div className={css.profile_info_left}>
                  <div className={css.profile_avatar}>
                    {currentUser.photo ? (
                      <img src={currentUser.photo} alt={userName} style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }} />
                    ) : (
                      userInitials
                    )}
                  </div>
                  <div className={css.profile_text}>
                    <h4>{userName}</h4>
                    <p>Trainer</p>
                  </div>
                </div>
              </div>

              <div className={css.profile_actions}>
                <LogoutButton onLogout={props.onLogout}>
                  <button className={css.parent_logout_btn}>
                    <IconSideLogout />
                    Log out
                  </button>
                </LogoutButton>
              </div>
            </div>
          )} */}
        </div>
      </PermanentDrawerWrapper>
    )
  );
}

export default withApiContext(withUserContext(SideMenu));
